import { combineReducers } from "redux";

import annotations from "./annotations";
import browser from "./browser";
import materials from "./materials";
import page from "./page";
import screen from "./screen";
import uploadDialog from "./uploadDialog";
import fabric from "./fabric";

export default combineReducers({
  annotations,
  browser,
  materials,
  page,
  screen,
  uploadDialog,
  fabric
});
